import { Theme } from '@mui/material/styles';

export default function CssBaseline(theme: Theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
        },
        html: {
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          width: '100%',
          height: '100%',
        },
        '#__next': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        '& ul, & ol': {
          paddingLeft: 24,
          '& li': {
            lineHeight: 2,
          },
        },
        blockquote: {
          display: 'block',
          borderWidth: '1px 0',
          borderStyle: 'solid',
          borderColor: theme.palette.divider,
          padding: '1.5em 0 1.5em',
          margin: '1.5em 0',
          position: 'relative',
          '&:before': {
            content: "'\u201C'",
            position: 'absolute',
            top: '0em',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: '#fff',
            width: '3rem',
            height: '2rem',
            color: theme.palette.grey[300],
            textAlign: 'center',
            font: "6em/1.08em 'PT Sans', sans-serif",
          },
        },
      },
    },
  };
}
